import React, { useEffect, useState } from 'react';
import { userApi } from '../services/api';
import { Trash2, Search, X, ShieldCheck } from 'lucide-react';
import toast from 'react-hot-toast';

export default function AdminUsers() {
  const [users,   setUsers]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [search,  setSearch]  = useState('');

  const load = async () => {
    setLoading(true);
    const res = await userApi.getAll();
    setUsers(res.data);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const handleRoleChange = async (id, role) => {
    if (!window.confirm(`Set this user's role to "${role}"?`)) return;
    try {
      await userApi.setRole(id, role);
      toast.success('Role updated (user must re-login for changes to take effect)');
      load();
    } catch {
      toast.error('Failed to update role');
    }
  };

  const handleDelete = async (id, email) => {
    if (!window.confirm(`Delete user "${email}"? This cannot be undone.`)) return;
    try {
      await userApi.delete(id);
      toast.success('User deleted');
      load();
    } catch {
      toast.error('Failed to delete user');
    }
  };

  const filtered = users.filter(
    (u) =>
      (u.email || '').toLowerCase().includes(search.toLowerCase()) ||
      (u.displayName || '').toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="admin-page">
      <h1 className="admin-page-title">Users</h1>

      <div className="search-box" style={{ maxWidth: 360, marginBottom: 20 }}>
        <Search size={18} className="search-icon" />
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search by name or email…"
          className="search-input"
        />
        {search && <button onClick={() => setSearch('')}><X size={16}/></button>}
      </div>

      {loading ? <div className="spinner"/> : (
        <div className="admin-table-wrapper">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Name</th><th>Email</th><th>Phone</th><th>Role</th><th>Joined</th><th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((u) => (
                <tr key={u.id}>
                  <td>{u.displayName || '—'}</td>
                  <td>{u.email}</td>
                  <td>{u.phone || '—'}</td>
                  <td>
                    <span className={`status-badge ${u.role === 'admin' ? 'status-delivered' : 'status-confirmed'}`}>
                      {u.role === 'admin' && <ShieldCheck size={14} />} {u.role}
                    </span>
                  </td>
                  <td>{u.createdAt ? new Date(u.createdAt).toLocaleDateString('en-IN') : '—'}</td>
                  <td className="actions-cell">
                    {u.role !== 'admin' ? (
                      <button className="btn btn-ghost btn-sm" onClick={() => handleRoleChange(u.id, 'admin')}>
                        Make Admin
                      </button>
                    ) : (
                      <button className="btn btn-ghost btn-sm" onClick={() => handleRoleChange(u.id, 'customer')}>
                        Revoke Admin
                      </button>
                    )}
                    <button className="icon-btn danger" onClick={() => handleDelete(u.id, u.email)}>
                      <Trash2 size={16}/>
                    </button>
                  </td>
                </tr>
              ))}
              {filtered.length === 0 && (
                <tr><td colSpan={6} className="empty-row">No users found</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
